import { inject, InjectionToken, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

export const LOCAL_STORAGE = new InjectionToken<Storage>('localStorage', {
  providedIn: 'root',
  factory: () => {
    const platformId = inject(PLATFORM_ID);
    return isPlatformBrowser(platformId) ? window.localStorage : ({
      getItem: (key: string) => platformId,
      setItem(key: string, value: string) {
      },
      clear() {
      }
    } as Storage);
  },
});
